var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66795_107495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 7.90625H0.410156C0.183641 7.90625 0 8.08989 0 8.31641C0 8.54292 0.183641 8.72656 0.410156 8.72656H7C7.22652 8.72656 7.41016 8.54292 7.41016 8.31641C7.41016 8.08989 7.22652 7.90625 7 7.90625Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.543H0.410156C0.183641 10.543 0 10.7266 0 10.9531C0 11.1796 0.183641 11.3633 0.410156 11.3633H7C7.22652 11.3633 7.41016 11.1796 7.41016 10.9531C7.41016 10.7266 7.22652 10.543 7 10.543Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.63672H0.410156C0.183641 2.63672 0 2.82036 0 3.04688C0 3.27339 0.183641 3.45703 0.410156 3.45703H7C7.22652 3.45703 7.41016 3.27339 7.41016 3.04688C7.41016 2.82036 7.22652 2.63672 7 2.63672Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.27344H0.410156C0.183641 5.27344 0 5.45708 0 5.68359C0 5.91011 0.183641 6.09375 0.410156 6.09375H7C7.22652 6.09375 7.41016 5.91011 7.41016 5.68359C7.41016 5.45708 7.22652 5.27344 7 5.27344Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2997 10.2248L11.8033 11.7212V2.27926L13.2997 3.7757C13.4599 3.93588 13.7196 3.93588 13.8798 3.7757C14.0399 3.61555 14.0399 3.35584 13.8798 3.19566L11.6832 0.999055C11.6063 0.922137 11.5019 0.878906 11.3932 0.878906C11.2844 0.878906 11.18 0.922137 11.1031 0.999055L8.90651 3.19566C8.74633 3.35584 8.74633 3.61552 8.90651 3.7757C9.06666 3.93588 9.32638 3.93588 9.48656 3.7757L10.983 2.27926V11.7212L9.48656 10.2248C9.3264 10.0646 9.06669 10.0646 8.90651 10.2248C8.74633 10.385 8.74633 10.6447 8.90651 10.8049L11.1031 13.0015C11.18 13.0784 11.2844 13.1216 11.3932 13.1216C11.5019 13.1216 11.6063 13.0784 11.6832 13.0015L13.8798 10.8049C14.0399 10.6447 14.0399 10.385 13.8798 10.2248C13.7196 10.0646 13.4599 10.0646 13.2997 10.2248Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66795_107495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/Sorting.454afd67324c1fc9d67be8589d4824a7.svg";
export { ForwardRef as ReactComponent };